<template>
  <span v-if="workingReward">
    <v-row class="mt-8">
      <v-col cols="12">
        <v-select v-if="level>0" label="Tiers" outlined dense :items="[1,2,3]" v-model="tiers" @change="onNewTiers" ref="tiers"/>
      </v-col>
    </v-row>

    <v-row class="mt-6" v-if="shouldInterestNonQualifyingRateBeShown()">
      <v-col cols="12">
        <v-text-field
          label="Non-qualifying rate"
          v-model="workingReward.nonQualifyingApr"
          type="number"
          hint="Ex. 0.75"
          suffix="%"
          hide-spin-buttons
          dense
          :rules="requiredAndPositiveRule"
          @input="onChange"
          name="nonQualifyingApr"
          ref="nonQualifyingApr"
        />
      </v-col>
    </v-row>

    <v-row class="mt-6">
      <v-col cols="12">
        <v-text-field
          :label="level == 0? 'Non-qualifying rate' : 'Tier 1 rate'"
          v-model="workingReward.tier1.apr"
          type="number"
          hint="Ex. 0.75"
          suffix="%"
          hide-spin-buttons
          dense
          :rules="requiredAndPositiveRule"
          @input="onChange"
          name="tier1apr"
        />
      </v-col>
    </v-row>

      <template v-if="tiers > 1">

        <v-row class="mt-6">
          <v-col cols="12">
            <v-text-field
              label="Tier 1 cap"
              v-model="workingReward.tier1.cap"
              type="number"
              hint="Ex. 15000.00"
              prefix="$"
              hide-spin-buttons
              dense
              :rules="requiredAndPositiveRule"
              @input="onChange"
              name="tier1cap"
              ref="tier1apr"
            />
          </v-col>
        </v-row>

        <v-row class="mt-6">
          <v-col cols="12">
            <v-text-field
              label="Tier 2 rate"
              v-model="workingReward.tier2.apr"
              type="number"
              hint="Ex. 0.75"
              suffix="%"
              hide-spin-buttons
              dense
              :rules="requiredAndPositiveRule"
              @input="onChange"
              name="tier2apr"
              ref="tier2apr"
            />
          </v-col>
        </v-row>

          <template v-if="tiers > 2">

            <v-row class="mt-6">
              <v-col cols="12">
                <v-text-field
                  label="Tier 2 cap"
                  v-model="workingReward.tier2.cap"
                  type="number"
                  hint="Ex. 15000.00"
                  prefix="$"
                  hide-spin-buttons
                  dense
                  :rules="requiredAndPositiveRule"
                  @input="onChange"
                  name="tier2cap"
                  ref="tier2cap"
                />
              </v-col>
            </v-row>

            <v-row class="mt-6">
              <v-col cols="12">
                <v-text-field
                  label="Tier 3 rate"
                  v-model="workingReward.tier3.apr"
                  type="number"
                  hint="Ex. 0.75"
                  suffix="%"
                  hide-spin-buttons
                  dense
                  :rules="requiredAndPositiveRule"
                  @input="onChange"
                  name="tier3apr"
                  ref="tier3apr"
                />
              </v-col>
            </v-row>
        </template>

      </template>
  </span>
</template>

<script lang="ts">
import Vue from 'vue';
import {
  Component, Prop, Watch,
} from 'vue-property-decorator';
import { InterestReward, Tier } from '@/api/product/levelrewards/rewards';
import { ValidationTool } from '@/util';

@Component
export default class InterestRewardEditor extends Vue {
  @Prop()
  value!:InterestReward;

  @Prop()
  level!:number;

  @Prop()
  productHasInterestReward!: boolean;

  @Prop()
  editingExistingReward!: boolean;

  workingReward:InterestReward | null = null;

  tiers: number = 1;

  requiredAndPositiveRule:Array<any> = [ValidationTool.requiredAndPositiveRuleFunction];

  mounted() {
    this.initialize();
  }

  @Watch('value')
  initialize() {
    this.workingReward = this.value.clone() as InterestReward;

    if (this.workingReward.tier3) {
      this.tiers = 3;
    } else if (this.workingReward.tier2) {
      this.tiers = 2;
    } else {
      this.tiers = 1;
    }
  }

  onChange() {
    this.$emit('input', this.workingReward);
  }

  shouldInterestNonQualifyingRateBeShown() : boolean {
    // This is not an edit of an existing reward, only show if there are no existing Interest Rewards
    // on any of the levels.
    return !this.editingExistingReward && !this.productHasInterestReward;
  }

  onNewTiers() {
    if (this.tiers > 1 && !this.workingReward!.tier2) {
        this.workingReward!.tier2 = { apr: '' };
    }

    if (this.tiers === 3 && !this.workingReward!.tier3) {
      this.workingReward!.tier3 = {
        apr: '',
      };
    } else if (this.tiers === 2) {
      this.workingReward!.tier2!.cap = null;
      this.workingReward!.tier3 = null;
    } else {
      this.workingReward!.tier2 = null;
      this.workingReward!.tier3 = null;
      this.workingReward!.tier1.cap = null;
    }
    this.onChange();
  }
}
</script>

<style lang="scss" scoped>
</style>
